import React from "react";

const YouTube = (props) => {
  if (props.video_id) {
    return (
      <div className="u-embed u-embed--16p9">
        <iframe
          src={`https://www.youtube.com/embed/${props.video_id}`}
          frameBorder="0"
          allowFullScreen
        />
      </div>
    );
  }

  // No data
  return null;
};

export default YouTube;
